(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
  var desktopQuery = window.matchMedia('(min-width: 750px)');

  function syncSlideVideos() {
    var videos = document.querySelectorAll('video.slide__media--desktop, video.slide__media--mobile');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      var isDesktopMedia = video.classList.contains('slide__media--desktop');
      if (isDesktopMedia === desktopQuery.matches) {
        if (video.paused) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    }
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', syncSlideVideos);
  } else {
    desktopQuery.addListener(syncSlideVideos);
  }
  syncSlideVideos();
})();
  } catch(e) { console.error(e); }
})();

})();
